<template>
    <v-collapse-group>
      <div class="a-ui-tab__block" v-for="(criterion, idx) in expertCriteria">
        <v-collapse-wrapper :active="true">
          <div class="a-ui-tab__control-panel">
            <div class="a-ui-tab__control" v-collapse-toggle>
              <div class="a-ui-tab__arrow"></div>
              <div class="a-ui-tab__number-block">{{idx + 1}}</div>
              <div class="a-ui-tab__title">
                <img class="table-tab__img-help"
                     src="@/assets/img/static/warning.svg"
                     v-if="wasCriterionChangedByParticipant(criterion)">
                {{criterion.criterionName}}
                <span v-if="lot.showWeight">
                    ({{$t('form.lot.weight-of-criterion-in-final-estimation')}} {{criterion.weight | percent}}%)
                </span>
              </div>
            </div>
          </div>
          <div class="a-ui-tab__content-block"
               v-collapse-content
               v-if="editable">
            <div class="a-container-form" v-if="criterion.till">
              <span class="a-width-100-percent a-color-red">
                Редактирование разрешено до <date-time tag="i" :value="criterion.till"></date-time>
                <div class="u-color-black a-formatted-text">{{criterion.tillDescription}}</div>
              </span>
            </div>

            <div class="a-ui-tab__content" v-if="criterion.showTextInput">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-ui-tab__file-item-left a-width-100-percent">
                  <div class="a-ui-tab__file-block-number">
                  </div>
                  <textarea class="a-textarea " rows="2" v-model="criterion.value" @blur="saveForm()" v-if="criterion.permissions.CAN_EDIT_CRITERIA"></textarea>
                  <p v-else>{{criterion.value}}</p>
                </div>
              </div>
            </div>
            <div class="a-ui-tab__content" v-if="criterion.showFileInput">
              <div class="a-ui-tab__file-flex-block" v-for="(file, idx) in criterion.files" :key="file.uid">
                <div class="a-ui-tab__file-item-left a-width-100-percent">
                  <div class="a-ui-tab__file-block-number">
                  </div>
                  <file-link :name="file.name"
                             :size="file.size"
                             :link="externalLink(file.uid)"
                             :removable="criterion.permissions.CAN_EDIT_CRITERIA"
                             :signed="file.hasSign"
                             :time="file.time"
                             @onsigncheck="onExpertCriteriaFileSignCheckClick(file.id)"
                             @remove="onRemoveFileClick({ criterionId: criterion.num, fileId: file.num})">
                  </file-link>
                </div>
              </div>

              <div class="a-ui-tab__file-flex-block" v-if="criterion.permissions.CAN_EDIT_CRITERIA">
                <div class="a-ui-tab__file-item-left a-width-100-percent">
                  <div class="a-ui-tab__file-block-number">
                  </div>

                  <file-picker :mode="criterion.files.length == 0 ? 'link': 'button'"
                               :signing="lot.permissions.SHOULD_BE_SIGNED"
                               @prepared="onFileReady($event, { criterionId: criterion.num })">
                  </file-picker>
                </div>
              </div>
            </div>
            <div class="a-ui-tab__content" v-if="lot.permissions.CAN_ESTIMATE_CRITERION_IN_PUBLIC_LOT">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-ui-tab__file-item-left">
                  <div class="a-ui-tab__file-block-number">
                  </div>
                  <div class="a-flex-start a-width-100-percent">
                    <div class="a-input-text-after-before a-width-100-percent">
                      <p>{{$t('labels.estimation')}}</p>
                      <input-estimation class="a-input a-input--w-140"
                                        v-model="criterion.estimate"
                                        @change="saveForm()"
                                        v-if="criterion.permissions.CAN_EDIT_CRITERIA_ESTIMATION"></input-estimation>
                      <p v-else>{{criterion.estimate | estimation}}</p>
                      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" v-if="criterion.permissions.CAN_EDIT_CRITERIA_ESTIMATION" @click="onSaveCriterionEstimation({ criterionId: criterion.num, estimation: criterion.estimate })">Сохранить</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="a-ui-tab__content" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST && criterion.permissions.CAN_ADJUST_CRITERIA">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-ui-tab__file-item-right a-width-100-percent">
                  <button class="gui-btn gui-btn--red " @click.prevent="onAllowCriterionUpdateClick({ criterionId: criterion.num, bid: bid.num })">{{$t('buttons.grant-participant-editing')}}</button>
                </div>
              </div>
            </div>
          </div>
        </v-collapse-wrapper>
      </div>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
      <approve-changes-dialog ref="approveChanges"
                              :lot="lot"
                              :bid="bid"
                              section="Экспертно оцениваемые критерии"
      ></approve-changes-dialog>
    </v-collapse-group>
</template>

<script>
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import CommonMixins from '../mixins/common'
  import Errors from '@/api/types/errors'
  import ApproveChangesDialog from "../../../common/dialogs/ApproveChangesDialog";

  export default {
    props: {
      lot: Object,
      bid: Object,
    },

    mixins: [
      CommonMixins
    ],

    components: {
      ApproveChangesDialog,
      SignatureDetailsDialog
    },

    computed: {
      expertCriteria() {
        return this.bid.criteria.expert;
      },

      editable() {
        return !!this.lot.request.permissions.HAS_ACCREDITATION;
      }
    },


    methods: {
      wasCriterionChangedByParticipant(criterion) {
        return !!_.find(this.lot.request.userChangesHistory, {
          bidNum: this.bid.num,
          criterion: criterion.num
        });
      },

      async onFileReady(file, options) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToPublicLotCriterion', {
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              bidId: this.bid.num,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('unable to attach file to expert criterion', e);
            this.globalErrorHandler(e,{
              'BAD_SIGNATURE': 'errors.public-lot.attaching-file-to-expert-criterion.bad-signature',
            }, 'errors.public-lot.attaching-file-to-expert-criterion.unknown');
          }
        })
      },

      async onRemoveFileClick(options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeFileFromPublicLotCriterion', {
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              bidId: this.bid.num,
              fileId: options.fileId
            });
          }
          catch(e) {
            console.error('unable to remove file from criterion', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onAllowCriterionUpdateClick(options) {
        this.$refs.approveChanges.open({
          onConfirm: async (info) => {
            await this.onAllowCriterionUpdate(options, info);
          }
        })
      },

      async onAllowCriterionUpdate(options, adjustInfo) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('allowCriterionUpdate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              bid: options.bid,
              description: adjustInfo.description,
              till: adjustInfo.till
            });
          }
          catch(e) {
            console.error('failed allowing document update', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onExpertCriteriaFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkExpertCriteriaFileSignature', {
              requestId: this.lot.request.id,
              fileId: fileId,
              bidId: this.bid.id
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking attached to criterion file signature', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
